import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Divider, Form, Input, Modal, Row, Table } from 'antd';
import Big from 'big.js';
import './ModalApprtion.less';

const FormItem = Form.Item;
const type = ['全部人员', '部门', '项目'];
const apportionType = ['非公摊', '单次公摊', '多次公摊'];

class ModalApportion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: '',
      visible: this.props.visible,
      avg: 0,
    };
  }

  componentDidMount() {
    const apportion = this.props.dataItem.apportion || {};
    this.handleChange(apportion.details || []);
  }

  componentWillReceiveProps(nextProps) {
    const apportion = nextProps.dataItem.apportion || {};
    this.handleChange(apportion.details || []);
  }

  findTypeName = value => {
    let typeName = '';
    this.props.expendType.forEach(item => {
      if (value === item.value) {
        typeName = item.key;
      }
    });
    return typeName;
  };

  columns = () => {
    return [
      {
        title: '分摊对象',
        dataIndex: 'originName',
        width: 100,
      },
      {
        title: '类型',
        dataIndex: 'originType',
        render: text => <span>{type[text]}</span>,
        width: 100,
      },
      {
        title: '金额',
        dataIndex: 'price',
        width: 160,
        render: (text, record) => {
          return (
            <div>
              {record.isEditable ? (
                <Input value={text} onChange={() => this.handlePriceChange(record)} />
              ) : (
                <span>{text}</span>
              )}
            </div>
          );
        },
      },
    ];
  };

  handleChange = params => {
    this.details = params;
    if (params.length > 0) {
      this.setState({
        count: this.getCountSum(params),
        avg: this.getAvg(params),
      });
    } else {
      this.setState({
        count: '-',
        avg: '-',
      });
    }
  };

  getCountSum = data => {
    const countSum = data.reduce((prev, curr) => {
      return prev + curr.count;
    }, 0);
    return countSum;
  };

  getAvg = params => {
    const { dataItem, dataInfo } = this.props;
    const price = dataItem.price || dataInfo.price;
    return new Big(price || 0).div(new Big(this.getCountSum(params))).toFixed(2);
  };

  render() {
    const { dataInfo, dataItem } = this.props;
    const { count, visible, avg } = this.state;
    const apportion = dataItem.apportion || {};
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
    };
    const formItemLayout2 = {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
    };
    const details = apportion.details || [];
    return (
      <Modal
        width={900}
        title="查看分摊方案"
        visible={visible}
        footer={false}
        onCancel={() => this.props.onCancel(false)}
      >
        <Form className="modalApportion">
          <Row>
            <Col span={8}>
              <FormItem label="分摊类型" {...formItemLayout}>
                {apportionType[apportion.type]}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="类型" {...formItemLayout}>
                {this.findTypeName(dataItem.type || dataInfo.type)}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="金额" {...formItemLayout}>
                {dataItem.price || dataInfo.price}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <FormItem label="分摊人数" {...formItemLayout}>
                {count}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="分摊人均金额" {...formItemLayout}>
                {avg}
              </FormItem>
            </Col>
            <Col span={8}>
              <FormItem label="分摊金额" {...formItemLayout}>
                {dataItem.price}
              </FormItem>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col span={8}>
              {+apportion.type === 1 || +apportion.type === 2 ? (
                <FormItem label="预算来源" {...formItemLayout}>
                  {apportion.groupName || ''}
                </FormItem>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label="预算分摊" {...formItemLayout2}>
                <Table
                  bordered
                  rowKey="originUuid"
                  columns={this.columns()}
                  dataSource={details}
                  scroll={{ y: 260 }}
                  pagination={false}
                  size="small"
                />
              </FormItem>
            </Col>
          </Row>

          {/* <Row>
							<Col span={24}>
								<FormItem label="分摊说明" labelCol={{ span:2 }} wrapperCol={{ span:22}}>
									<Input.TextArea placeholder="备注" type="textarea" autosize={{ minRows: 3, maxRows: 9 }} />
								</FormItem>
							</Col>
						</Row> */}
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  expendType: state.expend_type,
  company: state.company_list,
}))(Form.create()(ModalApportion));



// WEBPACK FOOTER //
// ./src/components/comm/apportion/ModalApportionShow.js